<template>
  <div class="">
    <div class="top-search-box">
      <topTab :rout="rout"></topTab>
    </div>
    <div class="content">
    <img class="page-logo" src="@/assets/home/10.png" alt="" />

    <div class="title">
      <div class="title-line"></div>
      <span>眼跳吉凶测算</span>
    </div>

    <div class="select-time">
      <span>眼跳时间：</span>
      <div class="select-box" @click="show = true">
        <span>{{ selectTime ? selectTime : "选择眼跳时间" }}</span>
        <i class="iconfont icon-triangle-left"></i>
      </div>
    </div>

    <div style="height: 3rem"></div>
    <div class="start-btn" @click="start">开始测算</div>
    <!-- <popup
      ref="popup"
      round
      v-model="show"
      position="bottom"
      :close-on-click-overlay="false"
      :lazy-render="false"
    >
      <datetime-picker
        ref="datetime"
        v-model="currentDate"
        type="datetime"
        title="选择时间"
        @confirm="confirm"
        @cancel="cancel"
      />
    </popup> -->
    <select-time v-model="show" :date="selectTime" @confirm="timeConfirm" />
    <shareBottomComp v-if="share == 1"></shareBottomComp>
</div>
  </div>
</template>

<script>
/**
@description:眼跳吉凶
@createTime:2021-08-25
@create:wq
*/
// import { DatetimePicker, Popup } from "vant";
import topTab from "@/components/topTab";

import selectTime from "../../../../components/selectTime.vue";
import shareBottomComp from '@/components/shareBottomComp'
import { shareJsSdk,HERF, getQueryString } from "@/utils/tool";
export default {
  name: "",
  props: {},
  components: { selectTime ,shareBottomComp,topTab},
  data() {
    return {
      show: false,
      currentDate: new Date(),
      selectTime: "",
      share:0,
      rout:[{
        name:'首页',
        path:'/home'
      },{
        name:'眼跳吉凶',
        path:'/ytjx'
      }]
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
     if (getQueryString("share")) {
      this.share = 1;
    }else{
      this.share = 0
    }
    shareJsSdk('ytjx','眼跳吉凶','','',HERF+'/image/10.png')
  },
  methods: {
    start() {
      if (this.selectTime === "") return this.Toast("请选择时间");
      this.api.saccade({ time: this.selectTime }).then((res) => {
        localStorage.setItem("result", JSON.stringify(res.data));
        this.$router.push("ytjxres");
      });
    },
    timeConfirm(data) {
      this.selectTime = data.date;
    },
    confirm() {
      const date = this.$refs.datetime
        .getPicker()
        .getValues()
        .join("-");
      this.selectTime = date;
      this.show = false;
    },
    cancel() {
      this.show = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  overflow: hidden;
  margin: 0 0.24rem;
}
.page-logo {
  width: 1.2rem;
  /* height: 1.2rem; */
  display: block;
  margin: 0.76rem auto;
}
.title {
  display: flex;
  align-items: center;

  font-size: 0.3rem;
  font-weight: 400;
  color: #f9647d;
  .title-line {
    width: 0.08rem;
    height: 0.34rem;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    border-radius: 0px 0.04rem 0.04rem 0px;
    margin-right: 0.1rem;
  }
}
.text {
  margin-top: 0.24rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: #666666;
  p {
    text-indent: 2em;
  }
}
.select-time {
  margin: 0.26rem 0;
  display: flex;
  align-items: center;
  > span {
    font-size: 0.3rem;
    font-weight: 400;
    color: #666666;
    margin-right: 0.38rem;
  }
  .select-box {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.24rem 0 0.44rem;
    border-radius: 0.5rem;
    background: #f0f0f0;
    border: 1px solid #e6e6e6;
    height: 0.76rem;
    span {
      font-size: 0.24rem;
      font-weight: 500;
      color: #cccccc;
    }
    i {
      font-size: 0.28rem;
      color: #53cedc;
    }
  }
}
.tips {
  margin-top: 0.7rem;
  display: flex;
  font-size: 0.24rem;
  font-weight: 400;
  color: #999999;
}

.start-btn {
  width: 7rem;
  height: 0.88rem;
  background: #4fd9d5;
  border-radius: 0.54rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 1.2rem;
  left: 50%;
  transform: translateX(-50%);

  font-size: 0.3rem;
  font-weight: 400;
  color: #ffffff;
}
</style>
